// extracted by mini-css-extract-plugin
module.exports = {"betaLabel":"a17280e0"};